"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authReducer = exports.initialState = void 0;
const types_1 = require("./types");
// Type-safe initialState!
exports.initialState = {
    isAuthenticated: false
};
// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer = (state = exports.initialState, action) => {
    switch (action.type) {
        case types_1.AuthActionTypes.LOGIN:
            return {
                user: action.user,
                isAuthenticated: action.isAuthenticated,
                register: action.register,
                login: action.login
            };
        case types_1.AuthActionTypes.FORGOT:
            return Object.assign(Object.assign({}, state), { forgot: action.forgot, emailExists: action.emailExists, error: action.message });
        case types_1.AuthActionTypes.LOGOUT:
            return {
                user: action.user,
                isAuthenticated: action.isAuthenticated,
                register: action.register
            };
        case types_1.AuthActionTypes.RESET:
            return Object.assign(Object.assign({}, state), { status: action.status });
        default:
            return state;
    }
};
exports.authReducer = reducer;
//# sourceMappingURL=reducer.js.map